import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6283042f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "body-container" }
const _hoisted_2 = { class: "SessionPopup" }
const _hoisted_3 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_SessionPopup = _resolveComponent("SessionPopup")!
  const _component_sidemenubar = _resolveComponent("sidemenubar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_navbar, {
      class: _normalizeClass({active:'bg-dark'})
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SessionPopup)
    ]),
    (_ctx.isSessionPopupVisible == true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["overlay", { active: 'isOverlayActive' }])
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex bg-dark",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeApps()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'w-40': _ctx.isToggling, 'w-10': !_ctx.isToggling,active:'bg-dark-blue' })
      }, [
        _createVNode(_component_sidemenubar)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content mt-12 flex-1 w-full h-screen overflow-y-scroll", { toggledstate: _ctx.isToggling }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _createVNode(_component_Footer)
      ], 2)
    ])
  ]))
}